import enLocale from '@/locales/en-US.json'

export const AVAILABLE_LOCALES = [
    'en-US',
    'es-ES',
    'de-DE',
    'fr-FR',
    'it-IT',
    'pt-BR',
    'tr-TR',
    'pl-PL',
    'id-ID',
] as const
export const SUPPORTED_LOCALES = [...AVAILABLE_LOCALES]

export type AvailableLocale = (typeof AVAILABLE_LOCALES)[number]
export type BaseLocaleMessages = typeof enLocale

export const LOCALE_IMPORT_MAP: Record<AvailableLocale, () => Promise<{ default: BaseLocaleMessages }>> = {
    'en-US': () => import('@/locales/en-US.json'),
    'es-ES': () => import('@/locales/es-ES.json'),
    'de-DE': () => import('@/locales/de-DE.json'),
    'fr-FR': () => import('@/locales/fr-FR.json'),
    'it-IT': () => import('@/locales/it-IT.json'),
    'pt-BR': () => import('@/locales/pt-BR.json'),
    'tr-TR': () => import('@/locales/tr-TR.json'),
    'pl-PL': () => import('@/locales/pl-PL.json'),
    'id-ID': () => import('@/locales/id-ID.json'),
}

export const LOCALE_TITLES: Record<AvailableLocale, string> = {
    'en-US': 'English',
    'es-ES': 'Español',
    'de-DE': 'Deutsch',
    'fr-FR': 'Français',
    'it-IT': 'Italiano',
    'pt-BR': 'Português',
    'tr-TR': 'Türkçe',
    'pl-PL': 'Polski',
    'id-ID': 'Indonesia',
}

// Using a simpler type definition to avoid TypeScript errors
const localeRouteNameMap: Record<string, string> = {
    // to locale
    en: 'en-US',
    es: 'es-ES',
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    br: 'pt-BR',
    tr: 'tr-TR',
    pl: 'pl-PL',
    id: 'id-ID',
    // to routeName
    'en-US': 'en',
    'es-ES': 'es',
    'de-DE': 'de',
    'fr-FR': 'fr',
    'it-IT': 'it',
    'pt-BR': 'br',
    'tr-TR': 'tr',
    'pl-PL': 'pl',
    'id-ID': 'id',
}

export const mapLocaleRouteParamName = (localeOrRoutName: string) => localeRouteNameMap[localeOrRoutName]

export const mapLocaleToHrefLang = (locale: AvailableLocale): string =>
    ({
        'en-US': 'en',
        'es-ES': 'es',
        'de-DE': 'de',
        'fr-FR': 'fr',
        'it-IT': 'it',
        'pt-BR': 'pt',
        'tr-TR': 'tr',
        'pl-PL': 'pl',
        'id-ID': 'id',
    })[locale]

export function resolveSupportedLocale(locale: string | undefined): AvailableLocale | undefined {
    if (!locale) {
        return undefined
    }
    if (SUPPORTED_LOCALES.includes(locale as AvailableLocale)) {
        return locale as AvailableLocale
    }

    const matchedLocale = SUPPORTED_LOCALES.find((loc) => loc.startsWith(locale))
    return matchedLocale as AvailableLocale
}
